import { Navigate } from "react-router-dom";
import useRBAC from "../hooks/useRBAC";

export default function ProtectedRoute({ resource, access, children }) {
  const { hasAccess, loading, permissions } = useRBAC();

  // 🔥 BLOCK until permissions are truly ready
  if (loading || permissions === null) {
    return <div style={{ padding: "20px" }}>Loading...</div>;
  }

  if (!hasAccess(resource, access)) {
    return <Navigate to="/" replace />;
  }

  return children;
}